export const CATEGORIAS = [
  "Smart TV", "Ar Condicionado", "Eletrônicos", "Eletrodomesticos", "Games", "Outras categorias",
];

export const MARCAS = ["TCL", "Samsung", "LG", "Hisense", "Electrolux", "Outras marcas"];

export const normalize = (value) => String(value || "")
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export function offerCategory(offer) {
  const category = normalize(offer.category || offer.category_type_name);
  const exact = CATEGORIAS.find((item) => normalize(item) === category);
  if (exact) return exact;
  if (/^(smart\s*tv[s]?|televis(ao|oes)|tv[s]?)$/.test(category)) return "Smart TV";
  if (/^ar[ -]condicionado[s]?$/.test(category)) return "Ar Condicionado";
  if (/^eletrodomestico[s]?$/.test(category)) return "Eletrodomesticos";
  if (/^(game[s]?|jogo[s]?|console[s]?)$/.test(category)) return "Games";
  if (/^(eletronico[s]?|celular(es)?|smartphone[s]?|smartwatch(es)?|informatica|notebook[s]?)$/.test(category)) return "Eletrônicos";
  return "Outras categorias";
}

export function offerBrand(offer) {
  // Quando a API informa a marca, ela prevalece sobre menções no título.
  const explicit = offer.brand || offer.marca;
  if (explicit) return MARCAS.find((item) => normalize(item) === normalize(explicit)) || "Outras marcas";
  const title = normalize(offer.name);
  return MARCAS.slice(0, -1).find((brand) => new RegExp(`\\b${normalize(brand)}\\b`).test(title)) || "Outras marcas";
}

export const SELO_META = {
  Excelente: { key: "excelente", label: "COMPRE SEM MEDO", band: true },
  Bom: { key: "bom", label: "OPORTUNIDADE", band: true },
  Neutro: { key: "neutro", label: "", band: false },
  Esgotou: { key: "esgotou", label: "", band: false },
};

export function offerSelo(offer) {
  const selo = SELO_META[offer?.selo] ? offer.selo : "Neutro";
  return { selo, ...SELO_META[selo] };
}

export function offerMatchesSelos(offer, selection) {
  const keys = ["Excelente", "Bom", "Esgotou"];
  if (keys.every(key => selection[key])) return true;
  return keys.some(key => selection[key] && offer?.selo === key);
}

export function liveCopyMatches(source, copy) {
  return (copy.board || "ao_vivo") === "ao_vivo"
    && ["name", "link", "cupom", "link_resgate"].every(key => String(source[key] || "") === String(copy[key] || ""))
    && (Number(source.offer_price) || 0) === (Number(copy.offer_price) || 0);
}

export function isHttpUrl(value) {
  try {
    const url = new URL(String(value || "").trim());
    return (url.protocol === "http:" || url.protocol === "https:") && !!url.hostname;
  } catch (_) {
    return false;
  }
}

export function parseCupomOrLink(value) {
  const raw = String(value || "").trim();
  if (!raw) return { cupom: "", link_resgate: "" };
  if (isHttpUrl(raw)) return { cupom: "", link_resgate: raw };
  return { cupom: raw.toUpperCase(), link_resgate: "" };
}

export function formatPrice(value) {
  const number = Number(value);
  if (!number || number <= 0) return null;
  return `R$ ${number.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function offerMerchant(offer) {
  // O domínio de compra ajuda ofertas antigas que têm um parceiro genérico.
  try {
    const host = new URL(offer.link).hostname.toLowerCase();
    const merchants = [
      ["Amazon", ["amazon.com.br", "amazon.com", "amzn.to"]],
      ["Shopee", ["shopee.com.br", "shope.ee"]],
      ["Mercado Livre", ["mercadolivre.com.br", "mercadolivre.com", "mercadolibre.com", "meli.la"]],
      ["Magalu", ["magazineluiza.com.br", "magazinevoce.com.br", "magalu.com", "divulgador.magalu.com"]],
    ];
    const match = merchants.find(([, domains]) => domains.some((domain) => host === domain || host.endsWith(`.${domain}`)));
    if (match) return match[0];
  } catch (_) {
    // Link ausente ou inválido: usa somente o parceiro fornecido pela API.
  }
  const partner = String(offer.partner_name || "").trim();
  return partner && !["whatsapp", "ofertas ao vivo", "ofertas-ao-vivo"].includes(normalize(partner)) ? partner : "Oferta";
}
